import type { ChangeEventHandler } from 'react'
import { useCallback } from 'react'
import styled from 'styled-components'
import ProductPaletteProvider from 'contexts/ProductPaletteContext'
import SwitchButton from 'LuxKit/Switch/SwitchButton'
import LuxPlusLogo from 'luxPlus/components/Logos/LuxPlusLogo'

const ToggleWrap = styled.span`
  display: inline-flex;
  flex-shrink: 0;
`

interface Props {
  checked: boolean
  disabled?: boolean
  onChange: () => void
}

function TripListLuxPlusToggle({ checked, disabled, onChange }: Props) {
  const handleChange = useCallback<ChangeEventHandler<HTMLInputElement>>(() => {
    onChange()
  }, [onChange])

  return (
    <ProductPaletteProvider palette="lux-plus">
      <ToggleWrap data-testid="trip-list-lux-plus-toggle">
        <SwitchButton
          checked={checked}
          disabled={disabled}
          onChange={handleChange}
        >
          <LuxPlusLogo inline height={10} />
        </SwitchButton>
      </ToggleWrap>
    </ProductPaletteProvider>
  )
}

export default TripListLuxPlusToggle
